import { Icon, Toggle } from '@ui/themed';

export function NestedToggleRow({
  label,
  checked,
  onChange,
}: {
  label: string;
  checked: boolean;
  onChange: (checked: boolean) => void;
}) {
  return (
    <div className="flex items-center justify-between bg-gray-50 p-4">
      <div className="flex flex-col">
        <span className="flex items-center align-middle text-gray-500 text-sm">
          <span className="mr-2">
            <Icon name="arrowRight" size="sm" />
          </span>
          {label}
        </span>
      </div>
      <Toggle checked={checked} onChange={onChange} />
    </div>
  );
}
